module.exports = __webpack_public_path__ + "static/media/title.cbfdbc6b.png";